<template>
  <div class="card-container">
    <a-row>
      <a-col :span="12">
        <a-menu v-model="current"
                :default-selected-keys="['hotel']"
                mode="horizontal">
          <a-menu-item key="ticket">
            <a :href="'/train-admin/channelShop/policy-ticket?distributorId='+globalDistributorId" rel="noopener noreferrer">飞机票</a>
          </a-menu-item>
          <a-menu-item key="train">
            <a :href="'/train-admin/channelShop/policy-train?distributorId='+globalDistributorId"  rel="noopener noreferrer">火车票</a>
          </a-menu-item>
          <a-menu-item key="hotel">
            <a :href="'/train-admin/channelShop/policy-hotel?distributorId='+globalDistributorId" rel="noopener noreferrer">酒店</a>
          </a-menu-item>
        </a-menu>
      </a-col>
      <a-col :span="12">
        <span style="float: right;margin-top:8px;">
          <a-button type="primary" @click="showPolicyCityModal">添加城市</a-button>
        </span>
      </a-col>
    </a-row>
  </div>
  <a-tabs :animated="false" default-active-key="2" @change="toHotelControl">
    <a-tab-pane key="1" tab="基础配置">

    </a-tab-pane>
    <a-tab-pane key="2" tab="标准配置">
      <a-breadcrumb>
        <a-breadcrumb-item>标准配置</a-breadcrumb-item>
        <a-breadcrumb-item>职级</a-breadcrumb-item>
        <a-breadcrumb-item><a href="">{{ controlQuery.levelName }}</a></a-breadcrumb-item>
      </a-breadcrumb>
      <a-table bordered :columns="policyHotelRuleColumns" :row-key="r => r.areaCode" :pagination="false" :data-source="policyHotelRuleData">
        <template v-slot:destination="{ text,record,index }">
          <a>{{ record.destination.province }}</a>
        </template>
        <template v-slot:policyStandard="{ text,record,index }">
          <a-col :span="22">
            <a-table :pagination="false" :showHeader="false" :row-key="r => r.index" :columns="cityColumns" :data-source="record.policyStandard">
              <template v-slot:cityList="{ text,record,index }">
                <span v-if="record.cityList[0].city">
                  {{ record.cityList[0].city }}:
                </span>
                <a-tag v-for="(item,index) in record.cityList" :key="index">
                  {{ item.area }}
                </a-tag>
              </template>
              <template v-slot:expenseStandards="{ text,record,index }">
                <a-input prefix="￥" v-model:value="record.expenseStandards" maxlength="8"/>
              </template>
              <template v-slot:operation="{ text,record,index }">
                <a-button type="danger" size="small" @click="deletePolicyHotelRule(record)" style="margin-right: 10px">删</a-button>
                <a-button type="primary" size="small" @click="editPolicyHotelRule(record)">存</a-button>
              </template>
            </a-table>
          </a-col>
          <a-col :span="2" style="padding-left: 8px;">
            <a-button type="primary" size="small" @click="addCityRule(record)">添加</a-button>
          </a-col>
        </template>
        <template v-slot:otherPolicyStandard="{ text,record,index }">
          <a-row>
            <a-col :span="20">
              <a-table :pagination="false" bordered :showHeader="false" :row-key="r => r.index" :columns="standardColumns" :data-source="record.otherPolicyStandard">
                <template v-slot:cityList="{ text,record,index }">
                 <span v-if="record.cityList[0].city">
                  {{ record.cityList[0].city }}:
                </span>
                  <a-tag v-for="(item,index) in record.cityList" :key="index">
                    {{ item.area }}
                  </a-tag>
                </template>
                <template v-slot:months="{ text,record,index }">
                  <a-tag v-for="(item,index) in record.months" style="margin: 2px;"> {{item}}月</a-tag>
                </template>
                <template v-slot:expenseStandards="{ text,record,index }">
                  <a-input prefix="￥" v-model:value="record.expenseStandards" maxlength="8"/>
                </template>
                <template v-slot:operation="{ text,record,index }">
                  <a-button type="danger" size="small" @click="deletePolicyHotelRule(record)" style="margin-right: 10px">删</a-button>
                  <a-button type="primary" size="small" @click="editPolicyHotelRule(record)">存</a-button>
                </template>
              </a-table>
            </a-col>
            <a-col :span="4" style="padding-left: 10px;">
              <a-button type="primary" size="small" @click="controlCityRule(record)">添加</a-button>
            </a-col>
          </a-row>

        </template>
      </a-table>
    </a-tab-pane>
  </a-tabs>

  <a-modal :width="windowWidth" v-model:visible="provinceModalVisible" title="选择省份" @ok="submitPolicyCity">
    <a-form :model="policyProvinceForm" layout="horizontal" :wrapper-col="wrapperCol">
      <a-form-item label="全国省份">
        <a-checkbox-group v-model:value="policyProvinceForm.city" name="city">
          <a-checkbox v-for="(item,index) in cityList" :key="index" :value="item.areaCode" name="city">
            {{ item.province }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
  </a-modal>

  <a-modal :width="windowWidth" v-model:visible="cityModalVisible" title="选择省份" @ok="addPolicyHotelRule">
    <a-tabs type="card" @change="getCityChildNodeList">
      <a-tab-pane :tab="item.city" v-for="(item,index) in addCityList" :key="item.areaCode"></a-tab-pane>
    </a-tabs>
    <a-form :model="cityChildNodeForm" layout="horizontal" :wrapper-col="wrapperCol">
      <a-form-item label="地区城市">
        <a-checkbox-group v-model:value="cityChildNodeForm.selectAreaList" name="city">
          <a-checkbox v-for="(item,index) in cityChildNodeForm.areaList" :key="index" :value="item.areaCode" name="city">
            {{ item.area }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="差标月份">
        <a-select
            mode="multiple"
            placeholder="差标月份"
            v-model:value="cityChildNodeForm.selectedMonth"
            style="width: 100%">
          <a-select-option v-for="(monthItem,index) in monthList" :key="index" :value="monthItem" name="monthList">
            {{ monthItem }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="差标金额">
        <a-input prefix="￥" v-model:value="cityChildNodeForm.cost" maxlength="8"/>
      </a-form-item>
    </a-form>
  </a-modal>

</template>

<script>
import {SmileOutlined, DownOutlined} from '@ant-design/icons-vue';
import {ref} from "vue";
import policy from '@axios/policy'
import {useRoute, useRouter} from "vue-router";
import {notification} from "ant-design-vue";

export default {
  components: {
    SmileOutlined,
    DownOutlined,
  },
  name: "index",
  setup() {
    const windowWidth = document.documentElement.clientWidth * 0.5
    const router = useRouter()
    const route = useRoute()
    const globalDistributorId = route.query.distributorId
    const controlQuery = {
      levelName: route.query.levelName,
      policyHotelBaseId: route.query.policyHotelBaseId,
      distributorId: globalDistributorId,
      policyBaseId: route.query.policyBaseId
    }

    let policyHotelRuleData = ref([])
    const findPolicyHotelRule = () => {
      const query = {
        distributorId: controlQuery.distributorId,
        policyHotelBaseId:controlQuery.policyHotelBaseId
      }
      policy.getPolicyHotelRule(query).then(p => {
        console.log("getPolicyHotelRule..", p)
        policyHotelRuleData.value = p
      })
    }
    findPolicyHotelRule()

    const toHotelControl = () => {
      router.push({
        name: 'policyHotelIndex',
        query: {
          distributorId: globalDistributorId
        }
      });
    }

    let standardColumnsData = ref([])

    let cityColumnsData = ref([])

    let provinceModalVisible = ref(false)

    const onChange = (e) => {
      console.log('radio checked', e.target.value);
    }
    const showPolicyCityModal = () => {
      findPolicyCity()
      provinceModalVisible.value = true;
    }


    let policyProvinceForm = ref({
      city: []
    })
    const submitPolicyCity = (e) => {
      console.log(policyProvinceForm.value.city)
      provinceModalVisible.value = false;
      const form = {
        areaCodeList: policyProvinceForm.value.city,
        policyBaseId: controlQuery.policyBaseId,
        policyHotelBaseId: controlQuery.policyHotelBaseId,
        type: 100
      }
      console.log(form)
      policy.createPolicyHotelRule(form).then(p => {
        console.log(p)
        findPolicyHotelRule()
      })
    }

    let cityList = ref([])
    const findPolicyCity = () => {
      const query = {
        parentId: 0
      }
      policy.getPolicyCity(query).then(policyCity => {
        cityList.value = policyCity
      })
    }

    //添加城市规则
    let cityModalVisible = ref(false)
    let addCityList = ref([])
    const addCityRule = (record) => {
      findCityChildNode(record)
      cityModalVisible.value = true
      cityChildNodeForm.value.policyHotelRuleId = record.id
      cityChildNodeForm.value.type = 100
    }

    let monthList = [
      "1月",
      "2月",
      "3月",
      "4月",
      "5月",
      "6月",
      "7月",
      "8月",
      "9月",
      "10月",
      "11月",
      "12月"
    ]

    const controlCityRule = (record) =>{
      cityModalVisible.value = true
      findCityChildNode(record)
      cityChildNodeForm.value.policyHotelRuleId = record.id
      cityChildNodeForm.value.type = 110
    }

    //添加城市节点 policy_hotel_rule_id
    let cityChildNodeForm = ref({
      policyHotelRuleInfoId: null,
      policyHotelRuleId: null,
      selectedMonth: monthList,
      selectAreaList: [],
      areaList: [],
      cost: 0,
      areaCode: null,
      type: 0
    })

    let policyCityForm = ref({})
    const addPolicyHotelRule = (e) => {
      const policyHotelRuleListForm = {
        policyHotelRuleId: cityChildNodeForm.value.policyHotelRuleId,
        id: cityChildNodeForm.value.policyHotelRuleInfoId,
        selectedMonth: cityChildNodeForm.value.selectedMonth,
        selectAreaList: cityChildNodeForm.value.selectAreaList,
        cost: cityChildNodeForm.value.cost,
        areaCode: cityChildNodeForm.value.areaCode,
        type: cityChildNodeForm.value.type
      }
      policy.updatePolicyHotelRule(policyHotelRuleListForm).then(p => {
        findPolicyHotelRule()
        cityModalVisible.value = false
      })
    }

    const editPolicyHotelRule = (record) =>{
      console.log(record)
      let cityList = []
      record.cityList.forEach(c =>{
        cityList.push(c.areaCode)
      })
      const policyHotelRuleListForm = {
        policyHotelRuleId: record.policyHotelRuleId,
        id: record.id,
        selectedMonth: record.months,
        selectAreaList: cityList,
        cost: record.expenseStandards,
        areaCode: record.areaCode,
        type: record.type === 'usual' ? 100 : 110
      }
      console.log(policyHotelRuleListForm)
      policy.updatePolicyHotelRule(policyHotelRuleListForm).then(p => {
        console.log(p)
        openNotificationWithIcon('success','修改成功！！！')
      })
    }

    const deletePolicyHotelRule = (e) => {
      const deletePolicy = {
        id: e.id,
        policyHotelRuleId: e.policyHotelRuleId
      }
      policy.deletePolicyHotelRule(deletePolicy).then(d => {
        console.log(d)
        findPolicyHotelRule()
      })
    }

    const getCityChildNodeList = (record) => {
      console.log(record,"---->getCityChildNodeList")
      let areaData = record
      if(!record.areaCode){
        addCityList.value.forEach(c =>{
          if(c["areaCode"] === record){
            areaData = c
          }
        })
      }
      policy.getCityChildNode(areaData.areaCode).then(c => {
        let areaList = []
        areaList.push(areaData)
        areaList = areaList.concat(c)
        cityChildNodeForm.value.areaList = areaList
        cityChildNodeForm.value.areaCode = areaData.areaCode
      })
    }


    const findCityChildNode = (record) => {
      policy.getCityChildNode(record.areaCode).then(c => {
        if(record.destination.provinceLevel === 'Y'){
          addCityList.value = [record.destination]
           let areaList = []
           areaList.push(record.destination)
           areaList = areaList.concat(c)
           cityChildNodeForm.value.areaList = areaList
           cityChildNodeForm.value.areaCode = record.areaCode
        }else{
          addCityList.value = c
          let defaultArea = c.length > 0 ? c[0] : null
          getCityChildNodeList(defaultArea)
        }
      })
    }


    const openNotificationWithIcon = (type,description) => {
      notification[type]({
        message: '提示信息',
        description:description,
      });
    }

    return {
      openNotificationWithIcon,
      findPolicyCity,
      globalDistributorId,
      controlCityRule,
      editPolicyHotelRule,
      deletePolicyHotelRule,
      monthList,
      addPolicyHotelRule,
      cityChildNodeForm,
      getCityChildNodeList,
      findCityChildNode,
      addCityList: addCityList,
      addCityRule,
      labelCol: {span: 4},
      wrapperCol: {span: 24},
      policyProvinceForm: policyProvinceForm,
      cityModalVisible: cityModalVisible,
      policyCityForm: policyCityForm,

      cityList,
      provinceModalVisible: provinceModalVisible,
      onChange,
      showPolicyCityModal,
      submitPolicyCity,

      toHotelControl,
      controlQuery,
      windowWidth,
      policyHotelRuleData: policyHotelRuleData,
      policyHotelRuleColumns: [
        {
          dataIndex: 'destination',
          title: '省份',
          key: 'destination',
          width: "10%",
          align: 'center',
          slots: {customRender: 'destination'},
        },
        {
          title: '城市/地区',
          dataIndex: 'policyStandard',
          align: 'center',
          key: 'policyStandard',
          width: "40%",
          slots: {customRender: 'policyStandard'},
        },
        {
          title: '管控',
          dataIndex: 'otherPolicyStandard',
          key: 'otherPolicyStandard',
          width: "40%",
          slots: {customRender: 'otherPolicyStandard'},
        }
      ],
      cityColumns: [
        {
          dataIndex: 'cityList',
          title: '管控类型',
          key: 'cityList',
          width: "70%",
          align: 'center',
          slots: {customRender: 'cityList'},
        },
        {
          title: '管控条件',
          dataIndex: 'expenseStandards',
          width: "15%",
          align: 'center',
          key: 'expenseStandards',
          slots: {customRender: 'expenseStandards'},
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: "15%",
          align: 'center',
          key: 'operation',
          slots: {customRender: 'operation'},
        }
      ],
      cityColumnsData: cityColumnsData,
      standardColumnsData: standardColumnsData,
      standardColumns: [
        {
          dataIndex: 'cityList',
          title: '管控类型',
          key: 'cityList',
          width: "40%",
          align: 'center',
          slots: {customRender: 'cityList'},
        },
        {
          title: '管控条件',
          dataIndex: 'months',
          width: "30%",
          align: 'center',
          key: 'months',
          slots: {customRender: 'months'},
        },
        {
          title: '条件规则',
          dataIndex: 'expenseStandards',
          key: 'expenseStandards',
          width: "15%",
          slots: {customRender: 'expenseStandards'},
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: "15%",
          align: 'center',
          key: 'operation',
          slots: {customRender: 'operation'},
        }
      ]
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.ant-checkbox-wrapper {
  margin: 10px 5px 15px;
}

.ant-tabs-nav-scroll {
  background-color: #F3F3F3;
}

.ant-col-4 {
  width: 100px;
}

.ant-col-offset-4 {
  margin-left: 100px;
}

.ant-tabs-bar {
  margin: 0;
}

.ant-breadcrumb {
  color: rgba(0, 0, 0, 0.45);
}

.ant-breadcrumb > span:last-child {
  color: #000000;
}

.ant-breadcrumb > span:last-child a {
  color: #000000;
}
.ant-tag{
  margin: 2px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>

.ant-menu-item-active {
  background-color: #F3F3F3;
}

.card-container {
  overflow: hidden;
  padding: 0px;
}

.ant-menu-item-selected {
  background-color: #F3F3F3;
  border-bottom: none;
  width: 100px;
}

.ant-menu-item-selected a, .ant-menu-item > a {
  text-align: center;
  font-size: 16px;
}

.ant-menu-item:hover {
  border-bottom: none;
  background-color: #F3F3F3;
}

.ant-menu-item {
  width: 100px;
}

.ant-tabs-nav-wrap, .ant-tabs-nav-scroll {
  background-color: #F3F3F3;
  height: 80px;
}

.ant-tabs-tab-active {
  background-color: #F3F3F3;
}

.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}


.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
  margin: 0;
  text-align: center;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #fff;
  background: #fff;
}

.ant-select {
  padding-bottom: 5px;
}
</style>
